import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'
import './Nav.css';
import govhackimage from './images/govhack.png';
import datanomnomimage from './images/datanomnom-logo copy.png';


const Nav = () => (
  <Router>
    <div>
      <div className="centeredmenu">
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/TabA">Postcode</Link></li>
          <li><Link to="/TabB">Centre</Link></li>
          <li><Link to="/TabC">Travel</Link></li>
        </ul>
      </div>
      <Route exact path="/" component={Home}/>
        <Route path="/TabA" component={TabA}/>
        <Route path="/TabB" component={TabB}/>
        <Route path="/TabC" component={TabC}/>
    </div>

  </Router>
)

const Home = () => (
  <div className="splash">

  <br></br>
  We all know that economic factors are heavily linked to region. Society and the economy rely on the effective movement of people and goods.
  <br></br><br></br>
  But what can we do with this information?... the answer is; lots of things!
  <br></br><br></br>
  Our <span className="highlightA"><Link to="/TabA">People of the Postcode</Link></span> visualisation shows the breakdown of average income per postcode. Exposing the relationship bewteen proximity to a city and the average level of taxation.
  <br></br><br></br>
  Ever wanted to see where the <span className="highlightB"><Link to="/TabB">Economic Centre</Link></span> of Sydney lies? It might not be where you think it is. We have visualised where it is now and where it is forecast to go.
  <br></br><br></br>
  Ever wondered how much people pay for their public transport? Or how well services difference demographic groups and centres in the city are? How areas on the fringe or remote of the city are serviced? Are some better off than others? Explore <span className="highlightC"><Link to="/TabC">Travel Times</Link></span> blended with the data from the two maps above.
  <br></br><br></br>
  Our submission guide <span className="highlightD"> <a href='https://vimeo.com/227578573' target="_blank">video</a></span> can help act as a user guide should you like to learn more about these maps and the rich interations available within them.
  <br></br><br></br>

  <div className="footer">

  </div>
  <div className="footer">
Built by...
  </div>
  <div className="footer">

  </div>
  <div className="footer">
Built for...
  </div>
  <div className="footer">

  </div>

  <img src={datanomnomimage} width="200px" height="200px" ></img>
  <img src={govhackimage} width="200px" height="200px"></img>
  </div>

)

const TabA = () => (
  <div className="wrapper">
    <div className="sidebar">
      <ul>
      <li>
      <h2>People of the Postcode</h2>
      </li>
      <li>
      This visualisation explores taxation data per people of each postcode to understand the geopgrapical positioning for financial statistics in a <span className="highlightA">'follow-the-money'</span> representation.
      <br></br><br></br>
      An easy assumption is that higher income areas cluster around capital cities. An <span className="highlightA">anomalyous sighting</span> is evident in southern regional areas in Western Australia showing consistent average income to higher income area in a capital city.
      <br></br><br></br>
      View <span className="highlightD"> <a href='https://vimeo.com/227578573' target="_blank">video</a></span> for examples

      <br></br><br></br>
      <div className='datasets'>
      Datasets:
      Individual Tax Returns - ATO - 2015
ABS Census - 2011
      </div>

      </li>

      <br></br>
        <li className="imageline">
      <img src={govhackimage} width="60%" height="50%"></img>
        </li>
      </ul>
    </div>
    <div className="mapwrapper">
      <iframe className='mapcontent' src="https://ovaclocked.carto.com/builder/8bf1cac3-ccf7-4361-8f6c-61301d133ae1/embed"></iframe>
    </div>
  </div>
)

const TabB = () => (
  <div className="wrapper">
    <div className="sidebar">
      <ul>
      <li>
      <h2>Economic Shift</h2>
      </li>
      <li>
      Where is the true economic centre of Sydney? Turns out it is somewhere next to the Parramatta river.
      <br></br><br></br>
      What is even more interesting is that the centre seems to be moving west almost <span className="highlightB">70 metres each year!</span> At this rate, 'Parramatta will become true economic centre of Sydney in the next 50 years'
<br></br><br></br>
Do our infrastructure priorities match this thesis?
<br></br><br></br>
Where do you think population and economic centres of the other capital cities are?
<br></br><br></br>
This can be applied to the other cities with similar data available.
<br></br><br></br>
View <span className="highlightD"> <a href='https://vimeo.com/227578573' target="_blank">video</a></span> for examples

<br></br><br></br>
<div className='datasets'>
Datasets:
Bureau of Transport Statistics, Transport for NSW - Population and Employment Projections
</div>
      </li>

      <br></br>
        <li className="imageline">
      <img src={govhackimage} width="60%" height="50%"></img>
        </li>
      </ul>
    </div>
    <div className="mapwrapper">
      <iframe className='mapcontent' src="https://ovaclocked.carto.com/builder/dc0673c3-e9ec-4de3-9b2a-005f2044996f/embed"></iframe>
    </div>
  </div>
)

const TabC = () => (
  <div className="wrapper">
    <div className="sidebar">
      <ul>
      <li>
      <h2>Travel Times</h2>
      </li>
        <li>
        This map combines the previous two and <span className="highlightC">explores the relationship</span> between travel time, income and centres in Sydney.
<br></br><br></br>
What areas are accessible in a reasonable commute time? What population can access them?
<br></br><br></br>
Which areas are only accessible by certain sects of the population?
<br></br><br></br>
Which areas / groups of people cannot access any of the centres at all? Are there high population
areas on the fringe which are disadvantaged?
<br></br><br></br>

View <span className="highlightD"> <a href='https://vimeo.com/227578573' target="_blank">video</a></span> for examples

<br></br><br></br>

<div className='datasets'>
Datasets:
TfNSW GTFS Timetable Data Release
Open Trip Planner (Routing)
Individual Tax Returns - ATO - 2015
ABS Census - 2011
</div>
        </li>
        <br></br>
        <li className="imageline">
      <img src={govhackimage} width="60%" height="50%"></img>
        </li>
      </ul>
    </div>
    <div className="mapwrapper">
      <iframe className='mapcontent' src="https://ovaclocked.carto.com/builder/dd4ca40e-393b-4551-8e70-87010cef8b41/embed"></iframe>
    </div>
  </div>
)

export default Nav



// WEBPACK FOOTER //
// ./src/Nav.js